/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/_realNames.js
// module id = 1649
// module chunks = 0